import React from 'react';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import FieldTitle from '../../../components/agv-forms-title';

const VEHICLE_COLORS = [
  { value: '#EF4444', label: 'Rouge' },
  { value: '#F97316', label: 'Orange' },
  { value: '#F59E0B', label: 'Ambre' },
  { value: '#EAB308', label: 'Jaune' },
  { value: '#84CC16', label: 'Vert clair' },
  { value: '#22C55E', label: 'Vert' },
  { value: '#10B981', label: 'Émeraude' },
  { value: '#14B8A6', label: 'Turquoise' },
  { value: '#06B6D4', label: 'Cyan' },
  { value: '#0EA5E9', label: 'Bleu ciel' },
  { value: '#3B82F6', label: 'Bleu' },
  { value: '#6366F1', label: 'Indigo' },
  { value: '#8B5CF6', label: 'Violet' },
  { value: '#A855F7', label: 'Pourpre' },
  { value: '#D946EF', label: 'Fuchsia' },
  { value: '#EC4899', label: 'Rose' },
  { value: '#6B7280', label: 'Gris' },
  { value: '#1F2937', label: 'Noir' },
];

export default function VehicleColorPicker({
  value,
  setValue,
  fieldTitle,
  isRequired,
}) {
  const selectedColor = VEHICLE_COLORS.find((color) => color.value === value);

  return (
    <div className="tw-flex tw-flex-col">
      {fieldTitle && <FieldTitle title={fieldTitle} isRequired={isRequired} />}
      <Listbox value={value} onChange={setValue}>
        {({ open }) => (
          <>
            <ListboxButton className="tw-relative tw-w-full tw-cursor-pointer tw-rounded-lg tw-bg-white tw-py-3 tw-pl-4 tw-pr-10 tw-text-left tw-shadow-sm tw-border tw-border-gray-300 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-main focus:tw-border-main tw-transition-all hover:tw-border-gray-400">
              <span className="tw-flex tw-items-center tw-gap-3">
                {selectedColor ? (
                  <>
                    <div
                      className="tw-w-6 tw-h-6 tw-rounded tw-border tw-border-gray-300"
                      style={{ backgroundColor: selectedColor.value }}
                    />
                    <span className="tw-block tw-truncate tw-font-medium tw-text-gray-900">
                      {selectedColor.label}
                    </span>
                  </>
                ) : (
                  <span className="tw-block tw-truncate tw-text-gray-400">
                    Sélectionnez une couleur
                  </span>
                )}
              </span>
              <span className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3">
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`tw-text-gray-400 tw-text-sm tw-transition-transform ${
                    open ? 'tw-rotate-180' : ''
                  }`}
                />
              </span>
            </ListboxButton>

            <ListboxOptions
              anchor="bottom"
              className="tw-w-[var(--button-width)] tw-rounded-lg tw-bg-white tw-shadow-lg tw-border tw-border-gray-200 tw-max-h-60 tw-overflow-auto tw-py-1 tw-mt-1 focus:tw-outline-none [--anchor-gap:4px]"
            >
              {VEHICLE_COLORS.map((color) => (
                <ListboxOption
                  key={color.value}
                  value={color.value}
                  className="tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-flex tw-items-center tw-gap-3 tw-transition-colors tw-cursor-pointer data-[selected]:tw-bg-main data-[selected]:tw-bg-opacity-10 data-[selected]:tw-text-main data-[focus]:tw-bg-gray-50"
                >
                  {({ selected }) => (
                    <>
                      <div
                        className="tw-w-6 tw-h-6 tw-rounded tw-border tw-border-gray-300 tw-flex-shrink-0"
                        style={{ backgroundColor: color.value }}
                      />
                      <span className="tw-flex-1 tw-font-medium">{color.label}</span>
                      {selected && (
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="tw-text-main tw-text-sm"
                        />
                      )}
                    </>
                  )}
                </ListboxOption>
              ))}
            </ListboxOptions>
          </>
        )}
      </Listbox>
    </div>
  );
}

